<template>
    <div>
        <vx-card title="Performance" subtitle="Lists of Employee Performance"  class="no-scroll-content" >


        <!-- <p>You can have a sebra effect by adding the property <code>stripe</code></p><br> -->
        <vs-button type="gradient" color="primary" @click="promptAddNewPerformance()"  icon-pack="feather" icon="icon-plus">Add</vs-button>

        <div class="vx-col w-full mb-base">
            <template>
                <vs-table stripe v-model="selected"  search  :data="employeePerformance">
                    <template slot="thead">
                        <vs-th>Appraisal Type</vs-th>
                        <vs-th>Market Segment</vs-th>
                        <vs-th>LOB</vs-th>
                        <vs-th>Year</vs-th>
                        <vs-th>From Date</vs-th>
                        <vs-th>To Date</vs-th>
                        <vs-th>Rate</vs-th>
                        <vs-th>Rating</vs-th>
                        <vs-th>Date Submitted</vs-th>
                        <vs-th>Date Evaluated</vs-th>
                        <vs-th>Evaluated By</vs-th>
                        <vs-th>Remarks</vs-th>
                        <vs-th>Action</vs-th>
                    </template>
                    <template slot-scope="{data}">
                        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                            <vs-td :data="data[indextr].appraisalTypeId">
                                {{ appraisalTypeName(data[indextr].appraisalTypeId).appraisalTypeName }}
                            </vs-td>
                            <vs-td :data="data[indextr].marketSegmentId">
                                {{ marketSegmentName(data[indextr].marketSegmentId).marketSegmentName }}
                            </vs-td>
                            <vs-td :data="data[indextr].lineofBusinessId">
                                {{ lineOfBusinessName(data[indextr].lineofBusinessId).lineOfBusinessName }}
                            </vs-td>
                            <vs-td :data="data[indextr].appraisalYear">
                                {{ data[indextr].appraisalYear }}
                            </vs-td>
                            
                            <vs-td :data="data[indextr].dateAppraisalStart">
                                {{data[indextr].dateAppraisalStart | fulldate}}
                            </vs-td>
                            <vs-td :data="data[indextr].dateAppraisalEnd">
                                {{data[indextr].dateAppraisalEnd | fulldate}}
                            </vs-td>
                            <vs-td :data="data[indextr].appraisalRate">
                                {{data[indextr].appraisalRate}}
                            </vs-td>
                            <vs-td :data="data[indextr].appraisalRatingId">
                                {{ appraisalRatingName(data[indextr].appraisalRatingId).appraisalRatingName }}
                            </vs-td>
                            <vs-td :data="data[indextr].dateSubmitted">
                                {{ data[indextr].dateSubmitted | fulldate }}
                            </vs-td>
                            <vs-td :data="data[indextr].dateEvaluated">
                                {{ data[indextr].dateEvaluated | fulldate}}
                            </vs-td>
                            <vs-td :data="data[indextr].evaluatedby">
                               {{ evaluatedByName(data[indextr].evaluatedby).firstName }}  {{ evaluatedByName(data[indextr].evaluatedby).lastName }}
                            </vs-td>
                            <vs-td :data="data[indextr].remarks">
                                {{ data[indextr].remarks }}
                            </vs-td>
                            <vs-td>
                                <div :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}">
                                    <feather-icon icon="Edit3Icon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="editRecord(data[indextr].id)" />
                                    <feather-icon icon="Trash2Icon" svgClasses="h-5 w-5 hover:text-danger cursor-pointer" @click="confirmDeleteRecord(data[indextr].id)" />
                                </div>
                            </vs-td>
                        </vs-tr>
                    </template>
                </vs-table>
            </template>
             
        </div>

            <!-- ADD PERFORMANCE -->
            <vs-prompt
                class="email-compose"
                title="Performance"
                accept-text= "Submit"
                @accept="onAddPerformance"
                :is-valid="validForm"
                :active.sync="activePromptNewPerformance">
                <vx-card title="Fill-out the following information">


                <div class="vx-row mb-3">
                    <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                        <span  class="text-sm">Appraisal Type</span><span style="color:red">*</span>
                        <v-select name="appraisalTypeId-name" class="w-full" v-model="appraisalType" label="appraisalTypeName" :options="appraisalTypeLookup" placeholder="Select Item" />

                    </div>
                   
                </div>
                <div class="vx-row mb-3">
                    <div class="vx-col sm:w-1/2 w-full mb-4">
                        <span  class="text-sm">Market Segment</span><span style="color:red">*</span>
                       <v-select name="marketSegment" class="w-full" v-model="marketSegment" label="marketSegmentName" :options="marketSegmentLookup"  placeholder="Select Item"/>

                    </div>
                    <div class="vx-col sm:w-1/2 w-full mb-4">
                        <span  class="text-sm">Line Of Business</span><span style="color:red">*</span>
                       <v-select name="lineOfBusinessId-name" class="w-full" v-model="lineOfBusiness" label="lineOfBusinessName" :options="lineOfBusinessLookup"  placeholder="Select Item" />

                    </div>
                </div>
                <div class="vx-row mb-3">
                    <div class="vx-col sm:w-1/2 w-full mb-4">
                        <span  class="text-sm">Appraisal Year</span>
                       <vs-input v-validate="'numeric|min_value:2020|max_value:3000'"  name="appraisal year" class="w-full" v-model="appraisalYear"  placeholder="Year" />
                        <span class="text-danger text-sm" v-show="errors.has('appraisal year')">{{ errors.first('appraisal year') }}</span>
                    </div>
                    <div class="vx-col sm:w-1/2 w-full mb-4">
                        <span  class="text-sm">Appraisal Rate</span>
                         <vs-input v-validate="'numeric|max_value:100'" name="appraisal rate" class="w-full" v-model="appraisalRate" placeholder="Rate" />
                         <span class="text-danger text-sm" v-show="errors.has('appraisal rate')">{{ errors.first('appraisal rate') }}</span>
                    </div>
                </div>
                 <div class="vx-row mb-3">
                    <div class="vx-col sm:w-1/2 w-full mb-4">
                        <span  class="text-sm">Appraisal Start</span><span style="color:red">*</span>
                       <datepicker name="dateAppraisalStart-name" class="w-full" v-model="dateAppraisalStart" placeholder="Select Date"/>
                    </div>
                    <div class="vx-col sm:w-1/2 w-full mb-4">
                        <span  class="text-sm">Appraisal End</span>
                        <datepicker name="dateAppraisalEnd-name" class="w-full" v-model="dateAppraisalEnd" placeholder="Select Date" />
                        
                    </div>
                </div>
                <div class="vx-row mb-3">
                    <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                        <span  class="text-sm">Appraisal Rating</span><span style="color:red">*</span>
                        <v-select name="appraisalRatingId-name" class="w-full" v-model="appraisalRating" label="appraisalRatingName" :options="appraisalRatingLookup"  placeholder="Select Item"/>
                    </div>
                </div>
                 <div class="vx-row mb-3">
                    <div class="vx-col sm:w-1/2 w-full mb-4">
                        <span  class="text-sm">Date Submitted</span><span style="color:red">*</span>
                       <datepicker name="dateSubmitted-name" class="w-full" v-model="dateSubmitted" placeholder="Select Date"/>
                    </div>
                    <div class="vx-col sm:w-1/2 w-full mb-4">
                        <span  class="text-sm">Date Evaluated</span><span style="color:red">*</span>
                        <datepicker name="dateEvaluated-name" class="w-full" v-model="dateEvaluated" placeholder="Select Date" />
                        
                    </div>
                </div>
               <div class="vx-row mb-3">
                    <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                        <span  class="text-sm">Evaluated By</span>
                        <vs-input v-validate="'alpha_spaces|max:50'" name="evaluated by" class="w-full" v-model="evaluatorName"  placeholder="Evaluated By" disabled="true"/>
                        <span class="text-danger text-sm" v-show="errors.has('evaluated by')">{{ errors.first('evaluated by') }}</span>
                    </div>
                </div>
                <div class="vx-row mb-3">
                    <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                        <span  class="text-sm">Remarks</span>
                        <vs-input name="remarks-name" class="w-full" v-model="remarks" placeholder="Remarks" />
                    </div>
                </div>
                 
               

            
                </vx-card>
            </vs-prompt>




                 <!-- EDIT PERFORMANCE -->
            <vs-prompt
                class="email-compose"
                title="Edit Performance"
                accept-text= "Submit"
                @accept="onEditPerformance"
                :is-valid="validForm"
                :active.sync="activePromptEditPerformance">
                <vx-card title="You may update the following information">

                <div class="vx-row mb-3">
                    <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                        <span  class="text-sm">Appraisal Type</span><span style="color:red">*</span>
                        <v-select name="appraisalTypeId-name" class="w-full" v-model="appraisalType" label="appraisalTypeName" :options="appraisalTypeLookup" placeholder="Select Item" />

                    </div>
                   
                </div>
                <div class="vx-row mb-3">
                    <div class="vx-col sm:w-1/2 w-full mb-4">
                        <span  class="text-sm">Market Segment</span><span style="color:red">*</span>
                       <v-select name="marketSegment" class="w-full" v-model="marketSegment" label="marketSegmentName" :options="marketSegmentLookup"  placeholder="Select Item"/>

                    </div>
                    <div class="vx-col sm:w-1/2 w-full mb-4">
                        <span  class="text-sm">Line Of Business</span><span style="color:red">*</span>
                       <v-select name="lineOfBusinessId-name" class="w-full" v-model="lineOfBusiness" label="lineOfBusinessName" :options="lineOfBusinessLookup"  placeholder="Select Item" />

                    </div>
                </div>
                <div class="vx-row mb-3">
                    <div class="vx-col sm:w-1/2 w-full mb-4">
                        <span  class="text-sm">Appraisal Year</span>
                       <vs-input v-validate="'numeric|min_value:2020|max_value:3000'"  name="appraisal year" class="w-full" v-model="appraisalYear"  placeholder="Year" />
                        <span class="text-danger text-sm" v-show="errors.has('appraisal year')">{{ errors.first('appraisal year') }}</span>
                    </div>
                    <div class="vx-col sm:w-1/2 w-full mb-4">
                        <span  class="text-sm">Appraisal Rate</span>
                         <vs-input v-validate="'numeric|max_value:100'" name="appraisal rate" class="w-full" v-model="appraisalRate" placeholder="Rate" />
                         <span class="text-danger text-sm" v-show="errors.has('appraisal rate')">{{ errors.first('appraisal rate') }}</span>
                    </div>
                </div>
                 <div class="vx-row mb-3">
                    <div class="vx-col sm:w-1/2 w-full mb-4">
                        <span  class="text-sm">Appraisal Start</span><span style="color:red">*</span>
                       <datepicker name="dateAppraisalStart-name" class="w-full" v-model="dateAppraisalStart" placeholder="Select Date"/>
                    </div>
                    <div class="vx-col sm:w-1/2 w-full mb-4">
                        <span  class="text-sm">Appraisal End</span>
                        <datepicker name="dateAppraisalEnd-name" class="w-full" v-model="dateAppraisalEnd" placeholder="Select Date" />
                        
                    </div>
                </div>
                <div class="vx-row mb-3">
                    <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                        <span  class="text-sm">Appraisal Rating</span><span style="color:red">*</span>
                        <v-select name="appraisalRatingId-name" class="w-full" v-model="appraisalRating" label="appraisalRatingName" :options="appraisalRatingLookup"  placeholder="Select Item"/>
                    </div>
                </div>
                 <div class="vx-row mb-3">
                    <div class="vx-col sm:w-1/2 w-full mb-4">
                        <span  class="text-sm">Date Submitted</span><span style="color:red">*</span>
                       <datepicker name="dateSubmitted-name" class="w-full" v-model="dateSubmitted" placeholder="Select Date"/>
                    </div>
                    <div class="vx-col sm:w-1/2 w-full mb-4">
                        <span  class="text-sm">Date Evaluated</span><span style="color:red">*</span>
                        <datepicker name="dateEvaluated-name" class="w-full" v-model="dateEvaluated" placeholder="Select Date" />
                        
                    </div>
                </div>
               <div class="vx-row mb-3">
                    <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                        <span  class="text-sm">Evaluated By</span>
                        <vs-input v-validate="'alpha_spaces|max:50'" name="evaluated by" class="w-full" v-model="evaluatorName"  placeholder="Evaluated By" disabled="true"/>
                        <span class="text-danger text-sm" v-show="errors.has('evaluated by')">{{ errors.first('evaluated by') }}</span>
                    </div>
                </div>
                <div class="vx-row mb-3">
                    <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                        <span  class="text-sm">Remarks</span>
                        <vs-input name="remarks-name" class="w-full" v-model="remarks" placeholder="Remarks" />
                    </div>
                </div>
                 
               
                 
                 
            
                </vx-card>
            </vs-prompt>
        </vx-card>
    </div>
</template>
<script>
import Datepicker from 'vuejs-datepicker'
import { en, he } from 'vuejs-datepicker/src/locale'

import moment from 'moment'
import vSelect from 'vue-select'

import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';

export default {
    data() {
        return {
            selected                    : [],
            id                          : 0,
            appraisalType               : [],
            lineOfBusiness              : [],
            marketSegment               : [],
            appraisalYear               : '',
            appraisalRate               : '',
            dateAppraisalStart          : null,
            dateAppraisalEnd            : null,
            appraisalRating             : [],
            dateSubmitted               : null,
            dateEvaluated               : null,
            // evaluatedBy                 : {},
            evaluatorName               : '',
            remarks                     : '',
            userId                      : null,

            uid                         : null,
            activePromptNewPerformance  : false,
            activePromptEditPerformance : false,

            format: "d MMMM yyyy",
        }
    },
    created() {

        
            this.uid = this.$route.params.id
            this.$vs.loading()
            this.$store.dispatch('lookup/getAllAppraisalTypeLookup').catch((err) => { console.log(err) })
            this.$store.dispatch('lookup/getAllMarketSegmentLookup').catch((err) => { console.log(err) })
            this.$store.dispatch('lookup/getAllLineOfBusinessLookup').then(res => { this.$vs.loading.close() }).catch((err) => { console.log(err) })
            this.$store.dispatch('lookup/getAllAppraisalRatingLookup')
                .then(res => { this.$vs.loading.close() })
                .catch((err) => { console.log(err) })
            this.$store.dispatch('hrms/getAllIdentification', this.uid).catch((err) => { console.log(err) })
            // this.$store.dispatch('hrms/getEmployeeByUserId', this.uid).catch((err) => { console.log(err) })
            this.employeePerformance = this.uid
            this.evaluatedByName = this.uid
            
    },
    computed: {
        employeePerformance: {
           
           get() { return this.$store.state.hrms.employeePerformance },
           set(value) { this.$store.dispatch('hrms/getAllPerformance',  value )}
            
        },
        validForm(){
            return this.appraisalType.appraisalTypeId != null &&
            this.marketSegment.marketSegmentId != null && this.appraisalRating.appraisalRatingId !=null &&
            this.lineOfBusiness.lineOfBusinessId != null && this.dateAppraisalStart != null &&
            this.dateSubmitted != null && this.dateEvaluated != null
        },
        appraisalTypeLookup() {
            return this.$store.state.lookup.getAllAppraisalTypeLookup 
        },
        appraisalTypeName() {
            return (id) => this.$store.getters['lookup/appraisalTypeLookup'](id)
        },
        marketSegmentLookup() {
            return this.$store.state.lookup.getAllMarketSegmentLookup 
        },
        marketSegmentName() {
            return (id) => this.$store.getters['lookup/marketSegmentLookup'](id)
        },
        lineOfBusinessLookup() {
            return this.$store.state.lookup.getAllLineOfBusinessLookup 
        },
        lineOfBusinessName() {
            return (id) => this.$store.getters['lookup/lineOfBusinessLookup'](id)
        },
        appraisalRatingLookup() {
            return this.$store.state.lookup.getAllAppraisalRatingLookup 
        },
        appraisalRatingName() {
            return (id) => this.$store.getters['lookup/appraisalRatingLookup'](id)
        },
        employeeIdentification() {
            return this.$store.getters['hrms/employeeIdentificationByUserId'](this.uid)
        },
        evaluatedBy() {
            return this.$store.state.hrms.employeeIdentification.immediateSupervisorId
            // return this.employeeIdentification.immediateSupervisorId 
            // set(value) {  this.$store.dispatch('hrms/getEmployeeByUserId', value ) }
        },
        evaluatedByName() {
            return (id) => this.$store.getters['hrms/getEmployeeByUserId'](id)
            
        }
       
    },
    methods: {
        promptAddNewPerformance() {
            // this.evaluatedBy = this.uid
            this.evaluatorName = this.evaluatedByName(this.evaluatedBy).firstName + ' ' + this.evaluatedByName(this.evaluatedBy).lastName
            this.activePromptNewPerformance = true
        },
        onAddPerformance() {
            this.$validator.validateAll().then(result => {
            if (result) {
                this.$vs.loading()

                const data = {
                    appraisalTypeId                 : this.appraisalType.appraisalTypeId,
                    marketSegmentId                 : this.marketSegment.marketSegmentId,
                    lineOfBusinessId                : this.lineOfBusiness.lineOfBusinessId,
                    appraisalYear                   : this.appraisalYear,
                    dateAppraisalStart              : this.dateAppraisalStart,
                    dateAppraisalEnd                : this.dateAppraisalEnd,
                    appraisalRate                   : this.appraisalRate,
                    appraisalRatingId               : this.appraisalRating.appraisalRatingId,
                    dateSubmitted                   : this.dateSubmitted,
                    dateEvaluated                   : this.dateEvaluated,
                    evaluatedby                     : this.evaluatedBy,
                    remarks                         : this.remarks,
                    userId                          : this.uid,
                    currentUserId           : this.$store.state.AppActiveUser.uid
                }

                this.$store.dispatch('hrms/AddPerformance', data)
                .then((response) =>{
                        this.$vs.loading.close()
                        this.$vs.notify({
                        title: 'Success',
                        text: 'Accredition Saved',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'success'                  
                        })
                })
                .catch(error => {
                        this.$vs.loading.close()
                        this.$vs.notify({
                        title: 'Error',
                        text: error.message,
                        iconPack: 'feather',
                        icon: 'icon-x-octagon',
                        color: 'danger'
                    })
                })
            } else {
                // form have errors
                this.$vs.notify({
                            title: 'Error',
                            text: error.message,
                            iconPack: 'feather',
                            icon: 'icon-x-octagon',
                            color: 'danger'
                        })
            }
            })
        },
        onEditPerformance() {
            this.$validator.validateAll().then(result => {
            if (result) {
                const data = {
                    id                              : this.id,
                    appraisalTypeId                 : this.appraisalType.appraisalTypeId,
                    marketSegmentId                 : this.marketSegment.marketSegmentId,
                    lineOfBusinessId                : this.lineOfBusiness.lineOfBusinessId,
                    appraisalYear                   : this.appraisalYear,
                    dateAppraisalStart              : this.dateAppraisalStart,
                    dateAppraisalEnd                : this.dateAppraisalEnd,
                    appraisalRate                   : this.appraisalRate,
                    appraisalRatingId               : this.appraisalRating.appraisalRatingId,
                    dateSubmitted                   : this.dateSubmitted,
                    dateEvaluated                   : this.dateEvaluated,
                    evaluatedby                     : this.evaluatedBy,
                    remarks                         : this.remarks,
                    userId                          : this.uid,
                    currentUserId           : this.$store.state.AppActiveUser.uid
                }
                this.$store.dispatch('hrms/UpdatePerformance', data)
                    .then(response => {
                            this.$vs.loading.close()
                            this.$vs.notify({
                            title: 'Success',
                            text: 'Performance Updated',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'success'                  
                            })
                    })
                    .catch(error => {
                            this.$vs.loading.close()
                            this.$vs.notify({
                            title: 'Error',
                            text: error.message,
                            iconPack: 'feather',
                            icon: 'icon-x-octagon',
                            color: 'danger'
                        })
                    })
                } else {
                // form have errors
                this.$vs.notify({
                            title: 'Error',
                            text: error.message,
                            iconPack: 'feather',
                            icon: 'icon-x-octagon',
                            color: 'danger'
                        })
            }
            })
        },
        editRecord(Id) {

            

            const e = this.$store.getters['hrms/employeePerformance'](Id)
            this.id             = e.id,
            this.appraisalType              = this.appraisalTypeName(e.appraisalTypeId),
            this.marketSegment              = this.marketSegmentName(e.marketSegmentId),
            this.lineOfBusiness             = this.lineOfBusinessName(e.lineofBusinessId),
            this.appraisalYear              = e.appraisalYear,
            this.dateAppraisalStart         = e.dateAppraisalStart,
            this.dateAppraisalEnd           = e.dateAppraisalEnd,
            this.appraisalRate              = e.appraisalRate,
            this.appraisalRating            = this.appraisalRatingName(e.appraisalRatingId),
            // this.evaluatedBy                = e.evaluatedby,
            this.dateSubmitted              = e.dateSubmitted,
            this.dateEvaluated              = e.dateEvaluated
            this.remarks                    = e.remarks,
            this.userId                     = e.userId

            // this.evaluatedBy                = e.userId
            this.evaluatorName              = this.evaluatedByName(e.evaluatedby).firstName + ' ' + this.evaluatedByName(e.evaluatedby).lastName

            this.activePromptEditPerformance = true
        },
        confirmDeleteRecord(id) {
            this.$store.dispatch('hrms/DeletePerformance', id)
            .then(res => {
                this.$vs.loading.close()
                        this.employeePerformance = this.uid
                        this.$vs.notify({
                        title: 'Success',
                        text: 'Performance Deleted',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'success'                  
                        })
                   })
                .catch(error => {
                        this.$vs.loading.close()
                        this.$vs.notify({
                        title: 'Error',
                        text: error.message,
                        iconPack: 'feather',
                        icon: 'icon-x-octagon',
                        color: 'danger'
                    })
                })
        }
    },
    components: {
        'v-select': vSelect,
        Datepicker,
        flatPickr,
        // VuePerfectScrollbar,
    },
}
</script>

<style lang="scss">
// @import "@/assets/scss/vuexy/apps/email.scss";
@import "@/assets/scss/vuexy/apps/simple-calendar.scss";
</style>